import { Helmet } from "react-helmet"
import {
    Box,
    ClickAwayListener,
    Stack,
    MenuItem,
    MenuList,
    Divider,
    InputAdornment,
    TextField,
    Select,
    Container,
    Grid,
    Typography,
    Grow,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Paper,
    Avatar,
} from "@mui/material"
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip"
import { makeStyles } from "@mui/styles"
import { useTranslation } from "react-i18next"
import { useNavigate, useSearchParams } from "react-router-dom"
import Search from "@mui/icons-material/Search"
import React, { useEffect, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import cssVariables from "../../../theme/cssVariables"
import { styled } from "@mui/styles"

import { ReactComponent as ChevronExpandDown } from "../../../assets/icons/chevron-expand-down.svg"
import { ReactComponent as ChevronExpandUp } from "../../../assets/icons/chevron-expand-up.svg"
import { ReactComponent as FilterStatus } from "../../../assets/icons/filter-status.svg"
import { ReactComponent as Nodata } from "../../../assets/icons/nodata.svg"
import defaultBanner from "../../../assets/images/announcement/default.jpg"

import CustomPagination from "../../../components/CustomPagination"

import * as Util from "../../../services/global.service"
import {
    getEmployeeList,
} from "../../../actions/managerDashboard"

const useStyles = makeStyles({
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    draggingListItem: {
        background: "rgb(235,235,235)",
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        ",
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        "&.Mui-selected": {
            color: cssVariables.color.primary + " !important",
        },
    },
    root: {
        display: "flex",
        width: "100%",
        flexWrap: "wrap",
    },
})
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
}

const EmployeeList = () => {
    const classes = useStyles()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const managerDashboardState = useSelector((state) => state.ManagerDashboard)
    const [list, setList] = React.useState([])
    const [filteredList, setFilteredList] = React.useState([])
    const [openStatus, setOpenStatus] = React.useState(false)
    const [search, setSearch] = React.useState("")
    const [perPage, setPerPage] = React.useState(50)
    const [currentPage, setCurrentPage] = React.useState(1)
    const [totalPage, setTotalPage] = React.useState(1)
    const [checkResired, setCheckRsquired] = React.useState({})
    const [reSet, setreSet] = React.useState(false)
    const anchorRefStatus = React.useRef(null)
    const [active, setActive] = React.useState(true)
    const [notActive, setNotActive] = React.useState(false)
    const [searchParams] = useSearchParams()

    const fetchData = () => {
        let orgIds = {
            organization_id: searchParams.get("organization_id").split(",")
        }
        dispatch(getEmployeeList(searchParams.get("filter"), orgIds)).then((resp) => {
            if (resp?.employee) {
                setList(resp.employee)
            }
        })
    }
    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault()
            setOpenStatus(false)
        } else if (event.key === "Escape") {
            setOpenStatus(false)
        }
    }
    const handleCloseStatus = (event) => {
        if (anchorRefStatus.current && anchorRefStatus.current.contains(event.target)) {
            return
        }
        setOpenStatus(false)
    }
    const filterActiveSearch = (data) => {
        let result = []
        let dataFilter = JSON.parse(JSON.stringify(data))
        if (notActive === false && active === false) {
            setFilteredList(result)
        } else if (notActive === true && active === true) {
            setFilteredList(data)
        } else {
            if (notActive === true) {
                let resultData = dataFilter.filter((rs) => rs?.status === "inactive")
                result = resultData
                setFilteredList(result)
            } else if (active === true) {
                let resultData = dataFilter.filter((rs) => rs?.status === "active")
                result = resultData
                setFilteredList(result)
            }
        }
    }

    const EditNotActive = (data) => {
        if (data === "notActive") {
            setNotActive(!notActive)
        } else if (data === "active") {
            setActive(!active)
        } else if (data === "selectAll") {
            if (notActive === true && active === true) {
                setNotActive(false)
                setActive(false)
            } else if (notActive === false && active === false) {
                setNotActive(true)
                setActive(true)
            } else if (notActive === true || active === true) {
                setNotActive(true)
                setActive(true)
            }
        }
    }

    const handleToggle = () => {
        setOpenStatus((prevOpen) => !prevOpen)
    }
    const handlesearch = (event) => {
        setSearch(event.target.value)
    }

    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage
        const lastPageIndex = firstPageIndex + perPage
        return filteredList.slice(firstPageIndex, lastPageIndex)
    }, [filteredList, currentPage, perPage])

    const handleTotalPage = () => {
        const List = [...filteredList]
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage)
        setTotalPage(totalPage)
    }

    const doSearch = (data) => {
        let result = []
        let dataSearch = JSON.parse(
            JSON.stringify(
                data !== undefined && data !== null ? data : list
            )
        )
        if (
            search !== "" 
        ) {
            let resultData = dataSearch.filter((rs) => {
                return Object.keys(rs).some((key) => {
                    if (
                        key === "code" ||
                        key === "position" ||
                        key === "team" ||
                        key === "options"
                    ) {
                        if (key !== "options") {
                            return (
                                rs[key]
                                    .toString()
                                    .toLowerCase()
                                    .indexOf(search.toString().toLowerCase()) !== -1
                            )
                        } else {
                            return (
                                rs?.[key]?.name_en
                                    .toString()
                                    .toLowerCase()
                                    .indexOf(search.toString().toLowerCase()) !== -1
                                ||
                                rs?.[key]?.name_th
                                    .toString()
                                    .toLowerCase()
                                    .indexOf(search.toString().toLowerCase()) !== -1
                            )
                        }
                    }
                })
            })
            result = resultData
        } else {
            result = dataSearch
        }
        filterActiveSearch(result)
    }

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value)
    }
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(
            (item) => item.type === "page" && item.selected
        )
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    }
    const toTimestamp = (strDate) => {
        if (strDate !== "" && strDate !== null && strDate !== undefined) {
            const dt = Date.parse(strDate)
            return dt / 1000
        } else {
            return 0
        }
    }
    let sortData = (key, direction) => {
        let result = [...filteredList]
        result = result.sort((a, b) => {
            if (direction) {
                return String(a[key]).localeCompare(String(b[key]))
            } else {
                return String(b[key]).localeCompare(String(a[key]))
            }
        })
        setFilteredList(result)
    }
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (openStatus) {
                setOpenStatus(false)
            }
        }
    }

    // useEffect
    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        handleTotalPage()
    }, [filteredList, perPage])

    useEffect(() => {
        doSearch()
    }, [list, search, notActive, active])
    // end useEffect

    const columnWidths = [
        "calc(10% - 12px)",
        "calc(30% - 12px)",
        "calc(20% - 12px)",
        "calc(20% - 12px)",
        "calc(12% - 12px)",
        "calc(12% - 12px)"
    ]

    return (
        <Box
            onScroll={onScroll}
            style={{ "max-height": "100%", "overflow-y": "auto" }}
        >
            <Helmet>
                <title>Employee List | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: "background.default",
                    minHeight: "100%",
                    py: 3,
                }}
            >
                <Container maxWidth="xl">
                    <Grid container mt={1} mb={1}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A">
                            <span style={styles.end}>{t("employeeList.label.title")}</span>
                        </Typography>
                    </Grid>
                    <Grid container mb={2}>
                        <Grid item display="flex" alignItems="center">
                            <Typography
                                color="#404349"
                                fontSize={36}
                                fontWeight="600"
                            >
                                {t("employeeList.label.title")}
                            </Typography>
                        </Grid>
                        <Grid item ml="auto" display="flex" alignItems="center">
                            <TextField
                                id="input-with-icon-textfield"
                                fullWidth
                                placeholder={t("employeeList.label.searchPlaceholder")}
                                size="small"
                                sx={{
                                    background: "#fff",
                                    width: "400px",
                                    height: "45px"
                                }}
                                value={search}
                                onChange={handlesearch}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search style={{ color: "#C4C4C4" }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container mb={3}>
                        <Grid item>
                            <Typography fontSize="16px" fontWeight="500" color="#939393">
                                {t("employeeList.label.totalEmployee")}: {list?.length ?? 0}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item>
                            <div className={classes.root}>
                                <Paper className={classes.flexPaper}>
                                    {/* TABLE HEADER */}
                                    <Box px="40px">
                                        <Box
                                            px="25px"
                                            py="19px"
                                            sx={{ display: "flex", "flex-direction": "row" }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    "flex-direction": "row",
                                                    width: columnWidths[0],
                                                }}
                                                pr="15px"
                                            >
                                                <Typography
                                                    fontSize={16}
                                                    lineHeight="23.96px"
                                                    color="#A0A0A0"
                                                    fontWeight="300px"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        width: "100%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        "max-width": "max-content",
                                                        "margin-right": "10px",
                                                    }}
                                                >
                                                    {t("employeeList.label.empID")}
                                                </Typography>
                                                <Typography
                                                    component="span"
                                                    style={{
                                                        "flex-direction": "column",
                                                        "justify-content": "center",
                                                        display: "flex",
                                                    }}
                                                >
                                                    <ChevronExpandUp
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("code", true)}
                                                    />
                                                    <ChevronExpandDown
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("code", false)}
                                                    />
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    "flex-direction": "row",
                                                    width: columnWidths[1],
                                                }}
                                                pr="15px"
                                            >
                                                <Typography
                                                    fontSize={16}
                                                    lineHeight="23.96px"
                                                    color="#A0A0A0"
                                                    fontWeight="300px"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        width: "100%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        "max-width": "max-content",
                                                        "margin-right": "10px",
                                                    }}
                                                >
                                                    {t("employeeList.label.employeeName")}
                                                </Typography>
                                                <Typography
                                                    component="span"
                                                    style={{
                                                        "flex-direction": "column",
                                                        "justify-content": "center",
                                                        display: "flex",
                                                    }}
                                                >
                                                    <ChevronExpandUp
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("fullname", true)}
                                                    />
                                                    <ChevronExpandDown
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("fullname", false)}
                                                    />
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    "flex-direction": "row",
                                                    width: columnWidths[2],
                                                }}
                                                pr="15px"
                                            >
                                                <Typography
                                                    fontSize={16}
                                                    lineHeight="23.96px"
                                                    color="#A0A0A0"
                                                    fontWeight="300px"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        width: "100%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        "max-width": "max-content",
                                                        "margin-right": "10px",
                                                    }}
                                                >
                                                    {t("employeeList.label.position")}
                                                </Typography>
                                                <Typography
                                                    component="span"
                                                    style={{
                                                        "flex-direction": "column",
                                                        "justify-content": "center",
                                                        display: "flex",
                                                    }}
                                                >
                                                    <ChevronExpandUp
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("position", true)}
                                                    />
                                                    <ChevronExpandDown
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("position", false)}
                                                    />
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    "flex-direction": "row",
                                                    width: columnWidths[3],
                                                }}
                                                pr="15px"
                                            >
                                                <Typography
                                                    fontSize={16}
                                                    lineHeight="23.96px"
                                                    color="#A0A0A0"
                                                    fontWeight="300px"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        width: "100%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        "max-width": "max-content",
                                                        "margin-right": "10px",
                                                    }}
                                                >
                                                    {t("employeeList.label.organization")}
                                                </Typography>
                                                <Typography
                                                    component="span"
                                                    style={{
                                                        "flex-direction": "column",
                                                        "justify-content": "center",
                                                        display: "flex",
                                                    }}
                                                >
                                                    <ChevronExpandUp
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("team", true)}
                                                    />
                                                    <ChevronExpandDown
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("team", false)}
                                                    />
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    "flex-direction": "row",
                                                    width: columnWidths[4],
                                                }}
                                                pr="15px"
                                            >
                                                <Typography
                                                    fontSize={16}
                                                    lineHeight="23.96px"
                                                    color="#A0A0A0"
                                                    fontWeight="300px"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        width: "100%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        "max-width": "max-content",
                                                        "margin-right": "10px",
                                                    }}
                                                >
                                                    {t("employeeList.label.status")}
                                                </Typography>
                                                {/* status stack */}
                                                <Stack direction="row" spacing={2}>
                                                    <div>
                                                        <FilterStatus
                                                            ref={anchorRefStatus}
                                                            id="composition-button"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={handleToggle}
                                                        />
                                                        <Popper
                                                            open={openStatus}
                                                            anchorEl={anchorRefStatus.current}
                                                            role={undefined}
                                                            placement="bottom-start"
                                                            transition
                                                            disablePortal
                                                            style={{ "z-index": "1" }}
                                                        >
                                                            {({ TransitionProps, placement }) => (
                                                                <Grow
                                                                    {...TransitionProps}
                                                                    style={{
                                                                        transformOrigin:
                                                                            placement === "bottom-start"
                                                                                ? "left top"
                                                                                : "left bottom",
                                                                    }}
                                                                >
                                                                    <Paper
                                                                        sx={{ "margin-top": "5px !important" }}
                                                                    >
                                                                        <ClickAwayListener
                                                                            onClickAway={handleCloseStatus}
                                                                        >
                                                                            <MenuList
                                                                                autoFocusItem={openStatus}
                                                                                id="composition-menu"
                                                                                aria-labelledby="composition-button"
                                                                                onKeyDown={handleListKeyDown}
                                                                            >
                                                                                <Box px="16px" py="6px">
                                                                                    <FormGroup>
                                                                                        <FormControlLabel
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    indeterminate={
                                                                                                        notActive !== active
                                                                                                    }
                                                                                                    onChange={(e) =>
                                                                                                        EditNotActive("selectAll")
                                                                                                    }
                                                                                                    checked={
                                                                                                        notActive === true &&
                                                                                                            active === true
                                                                                                            ? true
                                                                                                            : false
                                                                                                    }
                                                                                                />
                                                                                            }
                                                                                            label={t("competency.selectAll")}
                                                                                        />
                                                                                        <FormControlLabel
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    onChange={(e) =>
                                                                                                        EditNotActive("notActive")
                                                                                                    }
                                                                                                    checked={notActive}
                                                                                                />
                                                                                            }
                                                                                            label={t("employeeList.label.inactive")}
                                                                                        />
                                                                                        <FormControlLabel
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    onChange={(e) =>
                                                                                                        EditNotActive("active")
                                                                                                    }
                                                                                                    checked={active}
                                                                                                />
                                                                                            }
                                                                                            label={t("employeeList.label.active")}
                                                                                        />
                                                                                    </FormGroup>
                                                                                </Box>
                                                                            </MenuList>
                                                                        </ClickAwayListener>
                                                                    </Paper>
                                                                </Grow>
                                                            )}
                                                        </Popper>
                                                    </div>
                                                </Stack>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    "flex-direction": "row",
                                                    width: columnWidths[5],
                                                }}
                                                pr="15px"
                                            >
                                                <Typography
                                                    fontSize={16}
                                                    lineHeight="23.96px"
                                                    color="#A0A0A0"
                                                    fontWeight="300px"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        width: "100%",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        "max-width": "max-content",
                                                        "margin-right": "10px",
                                                    }}
                                                >
                                                    {t("employeeList.label.dataAsOf")}
                                                </Typography>
                                                <Typography
                                                    component="span"
                                                    style={{
                                                        "flex-direction": "column",
                                                        "justify-content": "center",
                                                        display: "flex",
                                                    }}
                                                >
                                                    <ChevronExpandUp
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("data_as_of", true)}
                                                    />
                                                    <ChevronExpandDown
                                                        style={{ cursor: "pointer" }}
                                                        onClick={(e) => sortData("data_as_of", false)}
                                                    />
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider width="100%" />
                                    </Box>
                                    {currentData !== undefined &&
                                        currentData !== null &&
                                        currentData.length > 0 ? (
                                        currentData.map((row, index) => (
                                            <Box px="40px" key={`emp-${index}`}>
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        position: "relative",
                                                        "&:before": {
                                                            content: '""',
                                                            position: "absolute",
                                                            height:
                                                                row?.status === "inactive" ? "100%" : "0px",
                                                            width:
                                                                row?.status === "inactive" ? "100%" : "0px",
                                                            top: "0",
                                                            background: "#FAFAFA",
                                                            opacity: "0.7",
                                                        },
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            height: "96px",
                                                            background: "#FFF",
                                                            width: "100%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                        px="25px"
                                                    >
                                                        <Box sx={{ width: columnWidths[0] }} pr="15px">
                                                            <Typography
                                                                fontSize={16}
                                                                lineHeight="23.96px"
                                                                fontWeight="300px"
                                                                sx={{
                                                                    whiteSpace: "nowrap",
                                                                    width: "100%",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                }}
                                                            >
                                                                {row?.code ?? "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: columnWidths[1] }} pr="15px">
                                                            <Grid container spacing={2} flexWrap="nowrap">
                                                                <Grid item display="flex" alignItems="center">
                                                                    <Avatar
                                                                        src={row?.photo}
                                                                    />
                                                                </Grid>
                                                                <Grid item>
                                                                    <Grid container>
                                                                        <Grid item display="flex" alignItems="center">
                                                                            <Typography fontSize="18px" fontWeight="500">
                                                                                {row?.options?.name_en ?? "-"}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item display="flex" alignItems="center">
                                                                            <Typography fontSize="18px" fontWeight="400">
                                                                                {row?.options?.name_th ?? "-"}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                width: columnWidths[2],
                                                                display: "flex",
                                                                justifyContent: "flex-start",
                                                                alignItems: "center",
                                                            }}
                                                            pr="15px"
                                                        >
                                                            <Typography
                                                                fontWeight="400"
                                                                fontSize="16px"
                                                            >
                                                                {row?.position ?? "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: columnWidths[3] }} pr="15px">
                                                            <Typography
                                                                fontWeight="400"
                                                                fontSize="16px"
                                                            >
                                                                {row?.team ?? "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: columnWidths[4] }} pr="15px">
                                                            <Typography
                                                                fontWeight="400"
                                                                fontSize={16}
                                                                lineHeight="23.92px"
                                                                sx={{
                                                                    color: "#5DA196",
                                                                    whiteSpace: "nowrap",
                                                                    width: "100%",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                }}
                                                            >
                                                                {row?.status === "active"
                                                                    ? "ACTIVE"
                                                                    : "INACTIVE"}
                                                            </Typography>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                "flex-direction": "column",
                                                                width: columnWidths[5],
                                                            }}
                                                            pr="15px"
                                                        >
                                                            <Typography
                                                                fontWeight="400"
                                                                fontSize="16px"
                                                                color="#404349"
                                                                sx={{
                                                                    width: "100%"
                                                                }}
                                                            >
                                                                {row?.data_as_of !== "" && Util.dateDayFormat(row?.data_as_of)}
                                                            </Typography>
                                                            <Typography
                                                                fontWeight="400"
                                                                fontSize="14px"
                                                                color="#A3A3A3"
                                                                sx={{
                                                                    width: "100%"
                                                                }}
                                                            >
                                                                {row?.data_as_of !== "" && `${Util.dateTimeFormat(row?.data_as_of)}`}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider width="100%" />
                                            </Box>
                                        ))
                                    ) : (
                                        <Box
                                            sx={{
                                                "padding-top": "50px",
                                                "text-align": "center",
                                                "padding-bottom": "500px",
                                            }}
                                        >
                                            <Nodata />
                                            <Typography
                                                color="#A0A0A0"
                                                fontWeight="500"
                                                fontSize={20}
                                                lineHeight="30px"
                                            >
                                                {t("label.noData")}
                                            </Typography>
                                        </Box>
                                    )}
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container mt={1} spacing={2}>
                        <Grid item xs sm md display="flex" alignItems="center">
                            <Box mr={1}>
                                <Typography variant="s14_fw400">
                                    {t("label.showMaxItems")}
                                </Typography>
                            </Box>
                            <Select
                                id="pagination"
                                variant="outlined"
                                defaultValue={10}
                                value={perPage}
                                onChange={handlePerPageChange}
                                displayEmpty
                                size="small"
                                className="white-bg"
                            >
                                <MenuItem value={50}>
                                    <Typography style={{ fontWeight: "300" }}>50</Typography>
                                </MenuItem>
                                <MenuItem value={100}>
                                    <Typography style={{ fontWeight: "300" }}>100</Typography>
                                </MenuItem>
                                <MenuItem value={200}>
                                    <Typography style={{ fontWeight: "300" }}>200</Typography>
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item display="flex" alignItems="center" ml="auto">
                            <Typography variant="s14_fw400">
                                {t("label.page")} {currentPage} {t("label.of")} {totalPage}
                            </Typography>
                        </Grid>
                        <Grid item ml="auto" display="flex" alignItems="center">
                            <CustomPagination
                                setCurrentPage={handleSetCurrentPage}
                                selected={currentPage}
                                count={totalPage}
                            ></CustomPagination>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    )
}
export default EmployeeList
